import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(2),

    '& .file': {
      '&-avatar': {
        backgroundColor: theme.palette.custom.surface[1],
        color: theme.palette.text.hint,
      },
      '&-title': {
        color: theme.palette.text.secondary,
      },
      '&-size': {
        color: theme.palette.text.hint,
      },
      '&-btn-download': {
        '&-label': {
          color: theme.palette.text.hint,
          marginRight: theme.spacing(1),
        },
      },
      [theme.breakpoints.down('sm')]: {
        '&-btn-download': {
          '&-label': {
            display: 'none',
          },
        },
      },
    },

    '& .skeleton-file-item': {
      '&-container': {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(3),
      },
      '&-avatar': {
        marginRight: theme.spacing(3),
        width: theme.spacing(6),
        height: theme.spacing(6),
      },
      '&-text': {
        flexGrow: 1,
        flexDirection: 'column',
        maxWidth: theme.spacing(50),
      },
      '&-icon': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        marginLeft: 'auto',
      },
    },
  },
  itemContainer: {
    margin: `0 ${theme.spacing(3)}px`,
  },
  divider: {
    marginLeft: theme.spacing(10),
  },
}));

export default styles;
